import './App.css';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// 懶加載頁面
const Card = lazy(() => import("./Card"));
const Home = lazy(() => import("./Home"));
const About = lazy(() => import("./About"));
const Research = lazy(() => import("./Research"));
const Project = lazy(() => import("./Project"));

function App() {
  return (
    <Router>
      {/* <Suspense fallback={<div>Loading...</div>}></Suspense> */}
      <Suspense>
        <div className="App" style={{ fontFamily: "'PingFang TC', 'Noto Sans TC', sans-serif" }}>
          <Routes>
            {/* 頂層路由 */}
            <Route path="/" element={<Card />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/research" element={<Research />} />
            <Route path="/project" element={<Project />} />
            
            {/* Manager 嵌套路由(Nested Routes) 
            <Route path="/manager" element={<ManagerLayout />}>
                <Route index element={<ManagerDashboard />} />

                <Route path="permission">
                  <Route index element={<Manager />} />
                  <Route path="add" element={<ManagerAdd />} />
                </Route>
              </Route>*/}
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
